import { render, staticRenderFns } from "./TeamIssueAverageModal.vue?vue&type=template&id=be621648"
import script from "./TeamIssueAverageModal.vue?vue&type=script&lang=js"
export * from "./TeamIssueAverageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports